"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WithLocalizationProvider = exports.LocalizationContext = exports.resourcesModel = void 0;
const react_1 = __importStar(require("react"));
const model_1 = require("../model");
exports.resourcesModel = new model_1.Model({
    languages: [],
    resources: {},
    setLocale: () => { },
    locale: 'en',
    isInitialized: false
});
exports.LocalizationContext = react_1.default.createContext(exports.resourcesModel.getValue());
exports.LocalizationContext.displayName = 'LocalizationContext';
function WithLocalizationProvider({ localStorageKey = 'localization:language', languages, defaultLanguageIso = 'en', children }) {
    const [modelValue, setModelValue] = (0, react_1.useState)(exports.resourcesModel.getValue());
    const languageKeys = languages.map((language) => language.iso);
    const isLanguageExists = (value) => languageKeys.includes(value);
    if (!languages.length) {
        throw new Error(`Languages array can not be empty`);
    }
    if (!isLanguageExists(defaultLanguageIso)) {
        throw new Error(`Language ${defaultLanguageIso} does not exists`);
    }
    const localStorageLanguage = localStorage.getItem(localStorageKey);
    const defaultLocale = localStorageLanguage && isLanguageExists(localStorageLanguage)
        ? localStorageLanguage
        : defaultLanguageIso;
    const [locale, setLocale] = (0, react_1.useState)(defaultLocale);
    (0, react_1.useEffect)(() => {
        exports.resourcesModel.update((val) => {
            val.languages = languages;
            val.setLocale = (locale) => {
                if (!isLanguageExists(locale)) {
                    throw new Error(`Language ${locale} does not exists`);
                }
                localStorage.setItem(localStorageKey, locale);
                setLocale(locale);
            };
            val.isInitialized = true;
        });
        setModelValue(exports.resourcesModel.getValue());
    }, []);
    (0, react_1.useEffect)(() => {
        var _a;
        const currentLanguage = languages.find((l) => l.iso === locale);
        const defaultLanguage = languages.find((l) => l.iso === defaultLanguageIso);
        const currentLanguageResources = (currentLanguage === null || currentLanguage === void 0 ? void 0 : currentLanguage.resources)
            ? currentLanguage.resources
            : defaultLanguage === null || defaultLanguage === void 0 ? void 0 : defaultLanguage.resources;
        const defaultResource = defaultLanguage === null || defaultLanguage === void 0 ? void 0 : defaultLanguage.resources;
        const newResources = {};
        for (const resourceKey in defaultResource) {
            if (!newResources[resourceKey]) {
                newResources[resourceKey] = {};
            }
            for (const localizationKey in defaultResource[resourceKey]) {
                newResources[resourceKey][localizationKey] =
                    ((_a = currentLanguageResources === null || currentLanguageResources === void 0 ? void 0 : currentLanguageResources[resourceKey]) === null || _a === void 0 ? void 0 : _a[localizationKey]) ||
                        defaultResource[resourceKey][localizationKey];
            }
        }
        exports.resourcesModel.update((val) => {
            if (!isLanguageExists(locale)) {
                throw new Error(`Language ${locale} does not exists`);
            }
            val.locale = locale;
            val.resources = newResources;
        });
        setModelValue(exports.resourcesModel.getValue());
    }, [locale]);
    return (react_1.default.createElement(exports.LocalizationContext.Provider, { value: modelValue }, children));
}
exports.WithLocalizationProvider = WithLocalizationProvider;
//# sourceMappingURL=context.js.map